"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// please do not delete React, as without it other projects could not be compiled: ReferenceError: React is not defined
const react_1 = __importDefault(require("react"));
const styles_1 = require("@mui/styles");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const i18n_1 = __importDefault(require("../i18n"));
const styles = () => ({
    buttonIcon: {
        marginRight: 8,
    },
});
/**
 * @typedef {object} SaveCloseButtonsProps
 * @property {boolean} noTextOnButtons Are the buttons without text
 * @property {any} theme Theme object (from this.state.theme)
 * @property {boolean} isIFrame bottom position 0 or 38 for iFrame
 * @property {boolean} newReact is used in new react
 * @property {function} onSave on Save handler
 * @property {function} onClose on Close handler
 *
 * @extends {React.Component<SaveCloseButtonsProps>}
 */
class SaveCloseButtons extends react_1.default.Component {
    /**
     * @param {SaveCloseButtonsProps} props
     */
    constructor(props) {
        super(props);
        const newReact = props.newReact === undefined ? true : props.newReact;
        try {
            this.isIFrame = !newReact && window.self !== window.top;
        }
        catch (e) {
            this.isIFrame = !newReact;
        }
    }
    render() {
        const noTextOnButtons = this.props.noTextOnButtons;
        const buttonStyle = {
            borderRadius: this.props.theme.saveToolbar.button.borderRadius || 3,
            height: this.props.theme.saveToolbar.button.height || 32,
        };
        const style = {
            bottom: this.isIFrame ? 38 : 0,
            left: this.props.paddingLeft || 0,
            right: 0,
            position: 'absolute',
            background: this.props.theme.saveToolbar.background,
        };
        if (this.props.dense) {
            style.minHeight = 48;
        }
        if (this.props.error) {
            buttonStyle.border = '1px solid red';
        }
        return react_1.default.createElement(material_1.Toolbar
        // position="absolute"
        , { 
            // position="absolute"
            style: style },
            react_1.default.createElement(material_1.Fab, { variant: "extended", "aria-label": "Save", disabled: !this.props.changed || this.props.error, onClick: () => this.props.onSave(false), style: buttonStyle },
                react_1.default.createElement(icons_material_1.Save, { className: !noTextOnButtons ? this.props.classes.buttonIcon : '' }),
                !noTextOnButtons && i18n_1.default.t('ra_Save')),
            react_1.default.createElement(material_1.Fab, { variant: "extended", "aria-label": "Save and close", disabled: !this.props.changed || this.props.error, onClick: () => this.props.onSave(true), style: Object.assign(Object.assign({}, buttonStyle), { marginLeft: 10 }) },
                react_1.default.createElement(icons_material_1.Save, { className: !noTextOnButtons ? this.props.classes.buttonIcon : '' }),
                !noTextOnButtons ? i18n_1.default.t('ra_Save and close') : '+',
                noTextOnButtons && react_1.default.createElement(icons_material_1.Close, null)),
            react_1.default.createElement("div", { style: { flexGrow: 1 } }),
            react_1.default.createElement(material_1.Fab, { variant: "extended", "aria-label": "Close", onClick: () => this.props.onClose(), style: buttonStyle },
                react_1.default.createElement(icons_material_1.Close, { className: !noTextOnButtons ? this.props.classes.buttonIcon : '' }),
                !noTextOnButtons && i18n_1.default.t('ra_Close')));
    }
}
/** @type {typeof SaveCloseButtons} */
const _export = (0, styles_1.withStyles)(styles)(SaveCloseButtons);
exports.default = _export;
